<template>
  <a :class="['cart-btn', isOpen && 'cart-btn--open', dummy && 'cart-btn--dummy']" ref="container">
    <div @click="open()" class="px-3 h-full flex justify-center items-center">
      <div>
        <i class="fas fa-shopping-cart ml-2"></i>
        <sup>{{ count }}</sup>
      </div>
    </div>

    <!-- The overlay -->
    <div v-if="!dummy" :class="['cart-overlay', isOpen && 'cart-overlay--open']">
      <div class="cart-overlay__title">
        <p class="uppercase font-semibold leading-none">Cart Summary</p>
        <a @click="close()">
          <i class="fas fa-times cursor-pointer"></i>
        </a>
      </div>

      <div class="mt-5 self-stretch flex flex-col">
        <cart-summary></cart-summary>
      </div>

      <div :class="['flex flex-col', empty && 'opacity-25']">
        <span class="text-sm">CART SUBTOTAL</span>
        <span class="text-smurfs-gold font-bold text-md">USD {{ total.toFixed(2) }}</span>
        <p v-if="!empty" class="text-md mt-2">
          Got a coupon code? Click
          <a href="/checkout">here</a> to add it
        </p>
      </div>

      <a
        :href="empty ? '/league-of-legends/lol-account' : '/checkout'"
        class="btn btn-gold text-md mt-2"
      >
        <span class="btn-content">{{ empty ? 'VIEW OUR ACCOUNTS' : 'PROCEED TO CHECKOUT' }}</span>
        <span class="icon">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </a>
    </div>
  </a>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { EventBus } from '../../shared/event-bus';

export default {
  props: {
    dummy: Boolean,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  created() {
    EventBus.$on('item-added-to-cart', () => {
      this.isOpen = true;
    });
  },

  computed: {
    ...mapState({
      items: state => state.cart.items,
    }),
    ...mapGetters('cart', ['total', 'count', 'empty']),
  },

  methods: {
    open() {
      this.isOpen = true;
      document.addEventListener('click', this.handlePotentiallyOutsideClick);

      const mobileMenu = document.querySelector('#toggle-mobile-navbar');
      const displayStyle = window.getComputedStyle(mobileMenu).display;
      if (displayStyle !== 'none') {
        // We are on mobile so we want to hide the overflow
        document.querySelector('body').classList.add("overflow-hidden")
      }
    },

    close() {
      this.isOpen = false;
      document.removeEventListener('click', this.handlePotentiallyOutsideClick);
      document.querySelector('body').classList.remove("overflow-hidden")
    },

    handlePotentiallyOutsideClick(event) {
      if (this.isOpen && !this.$refs.container.contains(event.target)) {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-btn {
  @apply h-full flex items-center justify-center;
  @apply border-b-2 border-transparent;
  @apply relative;
  @apply cursor-pointer;

  &--dummy {
    @apply cursor-auto;
  }

  &:hover,
  &--open,
  &--dummy {
    @apply border-smurfs-gold;
  }

  > span {
    @apply text-honestly-white text-sm;
    position: absolute;
    top: 0px;
    right: -10px;
  }

  .cart-overlay {
    @apply fixed inset-0;
    @apply bg-smog-grey;
    @apply p-5 shadow-lg cursor-auto;
    @apply hidden;
    z-index: 50;

    &--open {
      @apply block;
      overflow-y: auto;
    }

    &__title {
      @apply flex items-center justify-between;
      @apply border-b-2 border-metallic-grey;
      @apply pb-2;
    }
  }

  @screen md {
    .cart-overlay {
      @apply static inset-auto;
      @apply absolute right-0;
      top: 60px;
      width: 400px;
      max-height: calc(100vh - 135px);
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #181818 #2b2b2b;

      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-track {
        background: #2b2b2b;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #2b2b2b;
        border-radius: 10px;
        border: 10px solid #181818;
      }
    }
  }
}
</style>
